import React from "react";
import { FilterBar, Switch } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { BehaviorCategoryFilter, BehaviorDescriptionFilter, PrevalenceFilter, } from "../../../common";
import { initFilter } from "../../../fileBrowser/behavior/utils";
import { useReportSelector } from "../../../hooks";
import { isFilteredByLink } from "../../../utils";
import { selectFilteredByLink } from "../../store/behaviorSlice";
import styles from "./filter.module.scss";
const Filter = ({ filter, categories, descriptions, onFilterChange, }) => {
    const filteredByLink = useReportSelector(selectFilteredByLink);
    return (React.createElement(FilterBar, { filters: [
            {
                id: "description",
                control: (React.createElement(BehaviorDescriptionFilter, { label: "Search for behavior descriptions or IDs", description: filter.idAndDescription, descriptionOptions: descriptions, onChange: (value) => {
                        onFilterChange({ ...filter, idAndDescription: value });
                    }, className: styles.description, "data-filtered-by-link": isFilteredByLink(filter, initFilter, "idAndDescription", filteredByLink) })),
            },
            {
                id: "prevalence",
                grow: 0,
                control: (React.createElement(PrevalenceFilter, { prevalence: filter.prevalence, onChange: (value) => {
                        onFilterChange({ ...filter, prevalence: value });
                    } })),
            },
            {
                id: "category",
                width: "250px",
                control: (React.createElement(BehaviorCategoryFilter, { category: filter.category, categoryOptions: categories.toSorted(), onChange: (value) => {
                        onFilterChange({ ...filter, category: value });
                    } })),
            },
            {
                id: "ml-detection",
                fit: true,
                control: (React.createElement(Switch, { title: "Filter behaviors", label: "ML detection", checked: filter.showMlDetected, className: getClassName({
                        [styles.highlight]: isFilteredByLink(filter, initFilter, "showMlDetected", filteredByLink),
                    }), onChange: (event) => onFilterChange({
                        ...filter,
                        showMlDetected: event.target.checked,
                    }) })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map